import cookie from '@segment/analytics.js-core/lib/cookie';
var MAX_CACHE_SIZE = 100;
var COOKIE_NAME = 'atlassian_analytics_debug';
var TestingCache = /** @class */ (function () {
    function TestingCache() {
        var _this = this;
        this._bind = function () {
            if (window.testAnalytics) {
                return;
            }
            window.testAnalytics = {
                eventCache: [],
                events: function () { return window.testAnalytics.eventCache; },
                clear: function () {
                    window.testAnalytics.eventCache = [];
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                },
            };
        };
        this._cache = function (event) {
            if (window.testAnalytics.eventCache.length >= MAX_CACHE_SIZE) {
                window.testAnalytics.eventCache = window.testAnalytics.eventCache
                    .slice(1, window.testAnalytics.eventCache.length);
            }
            window.testAnalytics.eventCache.push(event);
        };
        this._shouldCacheEvent = function () { return !!cookie.get(COOKIE_NAME); };
        this.saveEvent = function (event) {
            if (event && _this._shouldCacheEvent()) {
                if (!window.testAnalytics) {
                    _this._bind();
                }
                _this._cache(event);
            }
        };
        if (this._shouldCacheEvent()) {
            this._bind();
        }
    }
    return TestingCache;
}());
export default TestingCache;
